const convertMinutesToHoursAndMinutes = totalMinutes => {
  const minutes = totalMinutes % 60;
  const hours = (totalMinutes - minutes) / 60;

  return { hours, minutes };
};

const getFormattedTimeFromMinutes = ({
  totalMinutes,
  hourLabel,
  hoursLabel,
  minuteLabel,
  minutesLabel,
}) => {
  const { hours, minutes } = convertMinutesToHoursAndMinutes(totalMinutes);

  const formattedHours =
    hours > 0 ? `${hours} ${hours > 1 ? hoursLabel : hourLabel}` : '';
  const formattedMinutes =
    minutes > 0 ? `${minutes} ${minutes > 1 ? minutesLabel : minuteLabel}` : '';

  return `${formattedHours} ${formattedMinutes}`.trim();
};

export { convertMinutesToHoursAndMinutes, getFormattedTimeFromMinutes };
